import axios, { AxiosPromise } from 'axios'

import ClientSDK from '../../App/ClientSDK'

export const fetchEstablishment = () => {
  return ClientSDK.instance().get('establishment')
}

export const fetchEstablishmentAnonymous = (
  establishmentId: string,
): AxiosPromise => {
  return axios.get('/api/anonymous/establishment', {
    params: { establishment_id: establishmentId },
  })
}
